import React, { useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import '../../css/Product.css';
import ProductSortLayer from './ProductSortLayer';
const imgURL = '/images';

interface HeaderType {
  totalCount: number;
  type: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
  isSort?: boolean;
  setIsSort: React.Dispatch<React.SetStateAction<boolean>>;
  sortKeyword: string;
  setSortKeyword: React.Dispatch<React.SetStateAction<string>>;
  setSortKeywordLabel: React.Dispatch<React.SetStateAction<string>>;
  sortDirection: string;
  setSortDirection: React.Dispatch<React.SetStateAction<string>>;
  sortKeywordLabel?: string;
  setIsFilter?: React.Dispatch<React.SetStateAction<boolean>>;
  filterTotal?: number;
}

export default function ProductHeader({
  totalCount,
  type,
  setType,
  isSort,
  setIsSort,
  sortKeyword,
  setSortKeyword,
  sortKeywordLabel,
  setSortKeywordLabel,
  sortDirection,
  setSortDirection,
  setIsFilter,
  filterTotal,
}: HeaderType) {
  const [isSortIcon, setIsSortIcon] = useState<boolean>(false); // 아이콘 변경
  const btnSortRef = useRef<any>(null);
  const location = useLocation();

  return (
    <div className="product_list_header">
      <div className="product_list_num">
        <span>{totalCount ? totalCount : 0}</span>개의 상품
      </div>
      <ul className="product_list_option">
        <li>
          {isMobile ? (
            <button
              className="btn_sort"
              onClick={(): void => {
                setIsSort((prev: boolean): boolean => !prev);
                setIsSortIcon(!isSortIcon);
              }}
            >
              {sortKeywordLabel ? sortKeywordLabel : '정렬'}
            </button>
          ) : (
            <>
              {/* pc */}
              <button
                ref={btnSortRef}
                className="btn_sort"
                onClick={(): void => {
                  setIsSort((prev: boolean): boolean => !prev);
                  setIsSortIcon(!isSortIcon);
                }}
              >
                {sortKeywordLabel ? sortKeywordLabel : '정렬'}
                {!isMobile && isSortIcon ? (
                  <img src={`${imgURL}/icon_arrow_up.png`} alt="" />
                ) : (
                  <img src={`${imgURL}/icon_arrow_down.png`} alt="" />
                )}
              </button>

              {isMobile ? null : (
                <>
                  {isSort && (
                    <ProductSortLayer
                      setIsModal={setIsSort}
                      setSortKeyword={setSortKeyword}
                      sortKeyword={sortKeyword}
                      setSortKeywordLabel={setSortKeywordLabel}
                      setSortDirection={setSortDirection}
                      sortDirection={sortDirection}
                      setIsSortIcon={setIsSortIcon}
                      btnSortRef={btnSortRef}
                    ></ProductSortLayer>
                  )}
                </>
              )}
            </>
          )}
        </li>
        {location.pathname.includes('festivalsection') ? null : (
          <li>
            <button
              className="btn_filter"
              onClick={(): void => {
                if (setIsFilter) {
                  setIsFilter(true);
                }
              }}
            >
              필터
              {filterTotal && <span>{filterTotal}</span>}
            </button>
          </li>
        )}
        <li>
          <button className="btn_listtype">
            <img
              onClick={(): void => {
                if (type === 'thumb') {
                  setType('list');
                } else {
                  setType('thumb');
                }
              }}
              src={`${type === 'thumb' ? `${imgURL}/icon_list.png` : `${imgURL}/icon_list_thumb.png`}`}
              alt="상품보기 썸네일형"
            />
          </button>
        </li>
      </ul>
    </div>
  );
}
